import React, { useState, useEffect } from 'react'
import Main from './Main'
import { useAuthState } from 'react-firebase-hooks/auth'
import { auth } from './firebase'
import firebase from 'firebase'
import Button from '@material-ui/core/Button';
import logo from './logo-bot.png'
import Typewriter from './utility'
import InstagramIcon from '@material-ui/icons/Instagram';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import ContactMailIcon from '@material-ui/icons/ContactMail';
import Footer from './Footer'
import Navbar from './Navbar'

const emailSignIn = () => auth.signInWithPopup(new firebase.auth.GoogleAuthProvider())

export default function App() {
  const [user] = useAuthState(auth)
  const [users, setUsers] = useState('')
  useEffect(() => {
    auth.onAuthStateChanged(user => {
      if (user) {
        setUsers(user)
      } else {
        setUsers('')
      }
    })
  }, [])
  return user !== null && auth ? <Main userInfo={[users]} /> : <div className="sign-in"> <SignIn /> </div>
}

const SignIn = () => {
  return (
    <>
    <Navbar/>
    <main className="logo-div">
      <h1 id="heading1" style={{ color: "orange", fontWeight: 800, fontSize: '50px' }} data-aos="fade-up">  STUDYBOT Beta v1.0.0 </h1>
      <Typewriter text="Better Health, Better Focus." data-aos="fade-up"> </Typewriter>
      <img src="https://hannahshiels.github.io/front-end-mentor/fylo-dark-theme-landing-page-master/images/illustration-intro.png" alt="illustration-intro" data-aos="fade-right"/>
      <section className="btn-div" data-aos="fade-left">
        <Button style={{ margin: '10px' }} className="add" variant="contained" startIcon={<ExitToAppIcon />} onClick={emailSignIn}> Sign in </Button>
        <Button style={{ margin: '10px' }} className="add" variant="contained" startIcon={<ContactMailIcon />} href="mailto:kangjohn00000@gmail.com"> Contact </Button>
      </section>
      <section className="services">
        <h1 data-aos="fade-up" style={{ fontWeight: 900, color: 'orange', marginBottom: '40px'}}> Our Services </h1>
        <div className="app-info">
          <div data-aos="fade-up"> <h1> Speech-controlled Bot </h1> STUDYBOT provides a bot that users can speak to allow it to perform certain tasks such as playing music, fetching quotes, and showing your performance through the day. </div>
          <div data-aos="fade-up"> <h1> Pomodoro Timer </h1> A timer that goes up to 25 minutes with each 5 minute intervals having alerts for users to take breaks and stretch to establish a balance between health and work.</div>
          <div data-aos="fade-up"> <h1> AI Posture Fix </h1> With the help of AI, STUDYBOT detects bad posture. Ideally, you should keep your camera at a normal distance and angle and it will give you alerts when you slouch or get distracted. </div>
          <div data-aos="fade-up"> <h1> Motivation </h1> From recoding the highest concentration time, motivating users with inspirational quotes to a todo-list, there are many features that will boost user's motivation to keep focusnig on their tasks. </div>
          <div data-aos="fade-up"> <h1> Music </h1> STUDYBOT has a command that allows you to play calm music for studies and work to enhance your productivity. It will randomly select a music and users will be able to randomly roll through the music menu. </div>
          <div data-aos="fade-up"> <h1> Resources</h1> STUDYBOT fetches a variety of learning resources based on user's choices and selections which maximizes the convenience and prevents wasting time searching the web. </div>
        </div>
      </section>
    </main>
    <Footer/>
    </>
  )
}